module.exports = __webpack_public_path__ + "media/images/users/information_provided_to_client_companies.ja-52c680fda98ca7c0e1ec7ce8e4e232dd.png";